import * as React from "react";
import { Parser } from "@json2csv/plainjs";
import { Box } from "@material-ui/core";

import { Button } from "components";
import { ValuationResultTrackList } from "services/valuation/types";
import theme from "theme";

export interface TrackListProps {
  tracks?: ValuationResultTrackList[];
  title: string;
  tracksTitleHeader?: string;
  countColor?: string;
  containerClass: string;
  platformContainerClass: string;
  collapsable: boolean;
  listingId?: number;
  maximumRows?: number;
  isTrackListHidden?: boolean;
}

export interface TrackListState {
  showMore: boolean;
}

class TrackList extends React.Component<TrackListProps, TrackListState> {
  public constructor(props: TrackListProps) {
    super(props);

    const { collapsable } = props;

    this.state = {
      showMore: !collapsable,
    };
  }

  private switchShowMore() {
    this.setState(prevState => ({
      showMore: !prevState.showMore,
    }));
  }
  private downloadCSV(tracks: ValuationResultTrackList[], listingId: number) {
    const fields = [
      { label: "Track Id", value: "trackId" },
      { label: "Title", value: "title" },
    ];
    const parser = new Parser({ fields });
    const csv = parser.parse(tracks);

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = !!listingId
      ? `Listing #${listingId} Included Track List.csv`
      : "Included Track List.csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public render() {
    const {
      tracks,
      title,
      countColor,
      containerClass,
      collapsable,
      platformContainerClass,
      maximumRows,
      listingId,
      isTrackListHidden,
    } = this.props;

    const { showMore } = this.state;
    const downloadOnly = tracks.length > 100;
    const maxRows = maximumRows || 10;
    const canExpand = collapsable && tracks.length > maxRows;

    return (
      <>
        <div
          className={`track-list ${containerClass} ${platformContainerClass}`}
        >
          <div className="track-list-header">
            {countColor && (
              <label
                style={{
                  color: countColor,
                  marginRight: "5px",
                  fontWeight: theme.typography.fontWeightMedium,
                }}
              >
                {tracks.length}
              </label>
            )}
            {title}
          </div>
          <div className="live-offers-title-separator" />
          {isTrackListHidden ? (
            <div className="hidden-track-list-div">
              <p className="hidden-track-list-text">
                Please refer to the Other Information section to download full
                track list.
              </p>
            </div>
          ) : (
            <>
              {!downloadOnly && (
                <>
                  <div className="track-list-table">
                    <div className="track-list-table-header">
                      <div className="track-list-table-row">
                        <div>
                          {this.props.tracksTitleHeader
                            ? this.props.tracksTitleHeader
                            : "Title"}
                        </div>
                        <div>Track ID</div>
                      </div>
                    </div>
                    <div className="track-list-table-content">
                      {(!collapsable || showMore
                        ? tracks
                        : tracks.slice(0, maxRows)
                      ).map((track, index) => (
                        <div className="track-list-table-row" key={index}>
                          <div>{track.title}</div>
                          <div>{track.trackId}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {collapsable && canExpand && (
                    <button
                      className="track-list-show-more"
                      onClick={() => this.switchShowMore()}
                    >
                      {showMore ? "Show Less" : "Show More"}
                    </button>
                  )}
                </>
              )}

              <Box mt={2} textAlign="center">
                <Button
                  variant="contained"
                  disableRipple
                  size="large"
                  onClick={() => this.downloadCSV(tracks, listingId)}
                >
                  Download Included Track List
                </Button>
              </Box>
            </>
          )}
        </div>
      </>
    );
  }
}

export default TrackList;
